import i18next from 'i18next';
import { LOCALE_MAP } from './locale-formatting';

const currentLocale = () => LOCALE_MAP[i18next.language] ?? 'pt-BR';

export const formatDateToDateBR = (dateToFormat, locale = currentLocale()) => {
    if (!dateToFormat) return ''
    return new Intl.DateTimeFormat(locale, {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    }).format(new Date(dateToFormat))
}

export const formatDateToDateBRPolish = (dateToFormat, locale = currentLocale()) => {
    if (!dateToFormat) return ''
    return new Intl.DateTimeFormat(locale, {
        day: '2-digit',
        month: 'long',
        year: 'numeric',
    }).format(new Date(dateToFormat))
}

export const formatDateTimeToDateTimeBR = (dateToFormat, locale = currentLocale()) => {
    if (!dateToFormat) return ''
    return new Intl.DateTimeFormat(locale, {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
    }).format(new Date(dateToFormat))
}

export const formatDateTimeWithTimezone = (dateToFormat, companyTimezone, locale = currentLocale()) => {
    if (!dateToFormat) return ''
    const tz = companyTimezone || 'UTC'
    const formatted = new Intl.DateTimeFormat(locale, {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        timeZone: tz,
    }).format(new Date(dateToFormat))
    if (!companyTimezone) {
        return `${formatted} (UTC)`
    }
    return formatted
}
